export default __webpack_public_path__ + "static/media/maradonaProfile.9d7433ed.png";